import _get from 'lodash/get';

export default function getIsInMsOffice() {
  return _get(window, ['location', 'ancestorOrigins', '0'], '').includes('office');
}
